import { useEffect, useState } from "react"
import { useSelector, useDispatch } from 'react-redux';
import { FetchHandler } from "../../Handlers/FetchHandler";
import { LocalStore } from "../../Handlers/LocalStore";
import { RdxStore } from "../../rdx/ReduxTypes";
import { PlantTypeType } from "../../rdx/Redux.DataReducerType";
import { PartialRecord } from "../../Types";
import { StringHelper } from "../../Handlers/Helpers";


export type LanguageCodeType = "no" | "en" | "en-us";
const ALL_LANGUAGES = ["no", "en", "en-us"];
const ALL_FIELDS = [
    "name",
    "specifictype",
    "public_description",

    "snippet_general_desription",
    "snippet_grow_and_plant",
    "snippet_takle_care",
    "snippet_fertilize",
    "snippet_crop",
    "snippet_advice"
];
const ALL_FIELDS_NAMES = {
    name: "Namn",
    specifictype: "Sort",
    public_description: "Beskriving",

    snippet_general_desription: "Allmän beskrivning*",
    snippet_grow_and_plant: "Odla och plantera*",
    snippet_takle_care: "Sköta*",
    snippet_fertilize: "Gödsla*",
    snippet_crop: "Beskära*",
    snippet_advice: "Tips*"
}
    ;
const getLocalArr = (key: string, defaultValue: string[]) => {
    const str = localStorage.getItem(key);
    if (!!str) {
        return JSON.parse(str)
    } else {
        return defaultValue;
    }
}
const setLocalArr = (key: string, v: string[]) => {
    const str = localStorage.setItem(key, JSON.stringify(v));
}
const LCOAL_KEY_LANGUAGES = "translations_langs";
const LCOAL_KEY_FIELDS = "translations_fields";

export const useTranslationsManager = () => {
    const ss: PlantTypeType[] = useSelector((state: RdxStore) => state.data.planttypes);
    const types: { value: string, label: string }[] = ss.map(o => { return { value: o.id, label: o.name } });

    //const options = [{ value: "-", label: "Inget filter" }].concat(types);

    const api = useTranslationsManagerApi();

    const [loading, setLoading] = useState<boolean>(false);

    const [dataRaw, setDataRaw] = useState<PlantTranslationType[]>([]);
    const [dataFiltered, setDataFiltered] = useState<PlantTranslationType[]>([]);
    const [snippets, setSnippets] = useState<Record<string, SnippetsType>>({});

    const [selectedLanguages, setSelectedLanguages] = useState<string[]>(getLocalArr(LCOAL_KEY_LANGUAGES, ALL_LANGUAGES));
    const [selectedFields, setSelectedFields] = useState<string[]>(getLocalArr(LCOAL_KEY_FIELDS, [ALL_FIELDS[0]]));
    const [selectedStates, setSelectedStates] = useState<TranslationStateType[]>([]);
    const [selectedTranslationStatus, setSelectedTranslationStatus] = useState<TranslationStatusType[]>([]);


    const selected_snippet_fieldname = selectedFields?.[0];
    const [showOnlyMissing, setShowOnlyetmissing] = useState<boolean>(false);

    const [changes, setChanges] = useState<ChangesType>({});
    const [snippetChanges, setSnippetChanges] = useState<SnippetsChangeType>({});

    const sortFunction = (a: PlantTranslationType, b: PlantTranslationType) => {
        const ak = a?.[sort?.field];
        const bk = b?.[sort?.field];
        const d = sort?.direction ?? "asc";

        if (ak > bk) { return d == "asc" ? 1 : -1; }
        else if (ak < bk) { return d == "asc" ? -1 : 1; }
        else { return 0; }

    }
    const [plantTypeId, setPlantTypeId] = useState<string>("ee4384cb-6220-41f7-9c7d-f3a9b2b0e621")

    const load = async () => {
        setLoading(true);
        setChanges({});
        setSnippetChanges({});

        let [_plantslist, _translations, _snippets] = await Promise.all([
            api.getByPlantTypeId(plantTypeId),
            api.getTranslations(),
            api.getSnippets()
        ]);

        // translate plants
        _plantslist.forEach(plant => {
            if (!!_translations[plant?.id]) {
                ALL_LANGUAGES.forEach(lang => {
                    if (!!_translations[plant?.id]?.[lang]) {
                        ALL_FIELDS.forEach(field => {
                            if (!!_translations[plant?.id]?.[lang]?.[field]) {
                                plant[lang][field] = _translations[plant?.id]?.[lang]?.[field];
                            }
                        })
                    }
                })
            }
        });
        // translate snippets
        Object.keys(_translations ?? {}).filter(key => (_translations[key] as any)?.type == "snippet").forEach(key => {
            if (!!_snippets[key]) {
                _snippets[key] = { ...(_snippets[key] as any), ..._translations[key] };
                // console.log("_snippets[key]:", _snippets[key]);
            }
        });


        console.log("plantslist:", _plantslist);
        console.log("translations:", _translations);
        console.log("_snippets:", _snippets["9411e12a-08dd-4d34-ba39-37badd988fd3"]);

        _plantslist.sort(sortFunction);

        setSnippets(_snippets);
        setDataRaw(_plantslist);
        setDataFiltered(_plantslist);

        setLoading(false);


    }







    useEffect(() => {
        if (selectedStates.length == 0 && selectedTranslationStatus.length == 0) {
            const filtered = dataRaw;
            setDataFiltered(filtered);
        } else {
            const filtered = dataRaw.filter(m => {

                if (!m?.[selected_snippet_fieldname]) {
                    return false;
                }
                const snippetId = m?.[selected_snippet_fieldname] as string;

                for (let i = 0; i < selectedLanguages.length; i++) {

                    const state = StringHelper.coalesce(snippets?.[snippetId]?.[selectedLanguages[i] + "_state"], "none") as TranslationStateType;
                    const translationStatus = StringHelper.coalesce(snippets?.[snippetId]?.[selectedLanguages[i] + "_translation_status"], "none") as TranslationStatusType;

                    return (selectedStates.length == 0 || selectedStates.indexOf(state) >= 0) && (selectedTranslationStatus.length == 0 || selectedTranslationStatus.indexOf(translationStatus) >= 0);
                }

                return true;
            });
            setDataFiltered(filtered);
        }
    }, [selectedStates, selectedTranslationStatus, selectedLanguages, showOnlyMissing, selectedFields])


    const resetFilter = () => {
        setDataFiltered(dataRaw);

    }
    const filterName = (e: string) => {
        const f = e?.toLowerCase() ?? "";
        setDataFiltered(dataRaw.filter((n, idx) => {
            return n?.name?.toLowerCase()?.includes(f)
        }));
    }

    const addUpdate = (plantid: string, lang: LanguageCodeType, field: string, value: string) => {
        const _value = value?.trim();
        let _new = { ...changes };
        console.log("--- update ---");
        console.log("new value for field " + field + ", lang: " + lang + ": '" + value + "'");
        var orig = dataRaw.find(m => m?.id == plantid);
        var origValue = orig?.[lang]?.[field];
        console.log("origValue:", origValue);

        if (!_new[plantid]) {
            _new[plantid] = {}
        }

        if (!_new[plantid][lang]) {
            _new[plantid][lang] = {}
        }

        if (!_new[plantid][lang]) {
            _new[plantid][lang] = {};
        }
        if (!!value && value != origValue) {
            _new[plantid][lang][field] = value;
        } else {
            delete _new[plantid][lang][field];
        }

        // Cleanup

        if (Object.keys(_new[plantid][lang]).length == 0) {
            delete _new[plantid][lang];
            console.log("cleanup, lang:", lang);

        }
        if (Object.keys(_new[plantid]).length == 0) {
            delete _new[plantid];
            console.log("cleanup, plantid:", plantid);
        }

        console.log("--- /update ---");

        setChanges(_new);
    }
    const addUpdateSnippet = (snippetId: string, lang: LanguageCodeType, value: string) => {
        let _new = { ...snippetChanges };
        console.log("--- update snippets ---");
        console.log("new value for snippet " + snippetId + ", lang: " + lang + ": '" + value + "'");
        // var orig = dataRaw.find(m => m?.id == plantid);
        var origValue = snippets?.[lang]?.[lang] ?? "";
        console.log("origValue:", snippets?.[lang]);

        if (value != origValue) {
            console.log("set value ", snippetId, lang);

            if (!_new[snippetId]) {
                _new[snippetId] = {}
            }

            console.log("new 1:", JSON.stringify(_new));
            _new[snippetId][lang] = value;
            console.log("new 2:", JSON.stringify(_new));
        } else {
            console.log("remove value ", JSON.stringify(_new));
            if (!!_new[snippetId]) {
                delete _new[snippetId][lang];
            }
        }

        // Cleanup

        console.log("pre cleanup:", JSON.stringify(_new));

        if (Object.keys(_new[snippetId] ?? {}).length == 0) {
            delete _new[snippetId];
            console.log("cleanup, snippetId:", snippetId);
        } else {
            console.log("Object.keys(_new[snippetId] ?? {}): ", Object.keys(_new?.[snippetId] ?? {}))
        }


        console.log("new:", JSON.stringify(_new));
        console.log("--- /update snippets ---");

        setSnippetChanges(_new);
    }
    const saveChanges = async () => {
        await api.setTranslations(changes);
        setChanges({});

        await api.setTranslationsSnippets(snippetChanges);

        let _new = { ...snippets } as any;
        Object.keys(snippetChanges ?? {}).forEach(id => {
            const s = snippetChanges[id];
            Object.keys(s).filter(key => ALL_LANGUAGES.indexOf(key) >= 0).forEach(l => {
                _new[id] = { ..._new[id], [l]: s?.[l] };
            });

        });
        setSnippets(_new);
        setSnippetChanges({});
    }
    const undoChanges = () => {
        setChanges({});
        setSnippets({ ...snippets });
        setSnippetChanges({});
    }

    // *********************** Sort ***********************
    const [sort, setSort] = useState<ObjectSortType>({ field: "name", direction: "asc" });
    const reSort = async () => {
        setLoading(true);
        let ret: PlantTranslationType[] = dataRaw;
        ret.sort(sortFunction);
        setDataRaw(ret);
        setDataFiltered(ret.filter((n, idx) => idx < 100));
        setLoading(false);
    }

    useEffect(() => { reSort(); }, [sort])

    // *********************** plantTypeId ***********************

    const setTranslationState = async (snippetid: string, language: string, state: TranslationStateType) => {
        let s = { ...snippets }
        // console.log("snippetid:", snippetid);
        // console.log("s[snippetid]:", s);
        // console.log("s[snippetid]:", s[snippetid]);
        s[snippetid][language + "_state"] = state;
        setSnippets(s);

        return await api.setTranslationState(snippetid, language, state);
    }

    return {
        loading,
        dataRaw,
        dataFiltered,
        snippets,
        load,
        setTranslationState,

        resetFilter,
        filterName,
        selectedStates,
        setSelectedStates: (e: TranslationStateType) => {
            if (selectedStates.indexOf(e) >= 0) {
                setSelectedStates(selectedStates.filter(m => m !== e));
            } else {
                setSelectedStates([...selectedStates, e]);
            }

        },
        selectedTranslationStatus,
        setSelectedTranslationStatus: (e: TranslationStatusType) => {
            if (selectedTranslationStatus.indexOf(e) >= 0) {
                setSelectedTranslationStatus(selectedTranslationStatus.filter(m => m !== e));
            } else {
                setSelectedTranslationStatus([...selectedTranslationStatus, e]);
            }

        },

        selected_snippet_fieldname,
        filterToSnippetsWithoutTranslations: (snippetField: string, language: LanguageCodeType) => {
            const filtered = dataRaw?.filter(m => {
                const snippetId = m?.[snippetField] as any;
                if (!snippetId) {
                    return false;
                }

                const str = snippets?.[snippetId]?.[language];
                return (str?.length ?? 0) == 0
            });
            setDataFiltered(filtered);
        },

        addUpdate,
        addUpdateSnippet,
        changes,
        snippetChanges,
        saveChanges,
        undoChanges,
        sort, setSort: (e: string) => {
            if (sort.field === e) {
                setSort({ ...sort, direction: sort?.direction === "asc" ? "desc" : "asc" });
            } else {
                setSort({ field: e, direction: "asc" })
            }
        },
        plantTypes: types,
        plantTypeId, setPlantTypeId,
        ALL_LANGUAGES,
        selectedLanguages,
        setLanguages: (e: string) => {

            if (selectedLanguages.indexOf(e) >= 0) {
                const t = selectedLanguages.filter(m => m !== e);
                setSelectedLanguages(t);
                setLocalArr(LCOAL_KEY_LANGUAGES, t);
            } else {
                const t = [...selectedLanguages, e];
                setSelectedLanguages(t);
                setLocalArr(LCOAL_KEY_LANGUAGES, t);
            }
        },
        ALL_FIELDS,
        ALL_FIELDS_NAMES,
        selectedFields: selectedFields,
        setSelectedFields: (e: string) => {

            if (selectedFields.indexOf(e) < 0) {
                const t = [e];
                console.log("new value:", t)
                setSelectedFields(t);
                setLocalArr(LCOAL_KEY_FIELDS, t);
            } else {
                console.log("do nothing");
                // const t = [e];// [...selectedFields, e];
                // setSelectedFields(t);
                // setLocalArr(LCOAL_KEY_FIELDS, t);
            }

        },
        translateText: async (text: string, language: string, options: TranslateTextOptions): Promise<string> => {
            setLoading(true);
            const str = await api.translateText(text, language, options);
            setLoading(false);
            return str;
        },
        translateTextMultiple: async (jobs: TranslateTextObjType[]) => {
            setLoading(true);
            const str = await api.translateTextMultiple(jobs);
            setLoading(false);
            return str;
        },
        deleteTranslationSnippet: async (id: string, language: LanguageCodeType): Promise<boolean> => {
            const success = await api.deleteTranslation(id, language);
            let _new = { ...snippets };
            if (!!_new[id] && success) {
                delete _new[id][language];
            }
            setSnippets(_new);
            return false;
        }

    }
}

export type TranslateTextOptions = {
    plantNameFrom: string
    plantNameTo: string
}
export type TranslateTextObjType = TranslateTextOptions & {
    id: string
    text: string
    language: string
    plantNameFrom: string
    plantNameTo: string
}

export const useTranslationsManagerApi = () => {

    return {
        getByPlantTypeId: async (plantTypeId: string): Promise<PlantTranslationType[]> => {
            const ret: PlantTranslationType[] = await FetchHandler.getJson("/api/translationplants?type=" + plantTypeId);
            return ret;
        },
        translateText: async (text: string, language: string, options: TranslateTextOptions) => {
            const url = "/api/translationplants/translate";

            const postObj = {
                text,
                plantNameFrom: options?.plantNameFrom,
                plantName: options?.plantNameTo,
                language,
                systemPrompt: "växtnamnet " + options?.plantNameFrom + " översätts som " + options?.plantNameTo
            };

            const { translatedText, success } = await FetchHandler.postJson(url, postObj);

            if (success) {
                return translatedText;
            } else {
                return "";
            }
            // return text + " på språk '" + language + "'";
        },
        translateTextMultiple: async (jobs: TranslateTextObjType[]) => {
            const url = "/api/translationplants/translate/multiple";

            const postObj = jobs.map(o => {
                return {
                    id: o.id,
                    text: o.text,
                    plantNameFrom: o?.plantNameFrom,
                    plantName: o?.plantNameTo,
                    language: o.language,
                    systemPrompt: "växtnamnet " + o?.plantNameFrom + " översätts som " + o?.plantNameTo
                }
            });

            const ret: { translatedText: string, success: boolean, id: string }[] = await FetchHandler.postJson(url, postObj);
            return ret;
            // return text + " på språk '" + language + "'";
        },
        setTranslations: async (changes: ChangesType) => {
            const ret: { success: boolean, errorMessage: string } = await FetchHandler.patchJson("/api/translationplants/translations/multiple", changes);
            return ret;
        },
        setTranslationState: async (snippetid: string, language: string, state: TranslationStateType) => {
            const url = "/api/translationplants/translations/snippets/state";
            const obj = {
                snippetid: snippetid,
                language: language,
                state: state
            }
            const ret: { success: boolean, errorMessage: string } = await FetchHandler.patchJson(url, obj);
        },
        getTranslations: async (): Promise<ChangesType> => {
            return await FetchHandler.getJson("/api/translationplants/translations")
        },
        getSnippets: async (): Promise<Record<string, SnippetsType>> => {
            const data = await FetchHandler.getJson("/api/snippet");
            let model = data.reduce((acc, curr) => (acc[curr.id] = curr, acc), {});
            return model;
        },
        setTranslationsSnippets: async (changes: SnippetsChangeType) => {
            const ret: { success: boolean, errorMessage: string } = await FetchHandler.patchJson("/api/translationplants/translations/snippets/multiple", changes);
            return ret;
        },
        deleteTranslation: async (id: string, language: LanguageCodeType): Promise<boolean> => {
            const url = "/api/translationplants/translations/" + id + "/" + language;
            return await FetchHandler.delete(url);
        }
    }
}

// ############################## Types ##############################
export type TranslationStatusType = "needs_review" | "ok" | undefined;
export const TranslationStatusTypeText: Record<TranslationStatusType, string> = {
    needs_review: "needs_review",
    ok: "ok"
}

export type TranslationStateType = "none" | "updated" | "reviewed" | "invalid";
export const TranslationStateTypeText: Record<TranslationStateType, string> = {
    none: "Ingen",
    updated: "Uppdaterad",
    reviewed: "Godkänd",
    invalid: "Ej godkänd"
}

export type SetTranslationArgsType = {
    plantid: string
    language: string
    translations: Record<string, string>
}

export type PlantTranslationType = Record<string, SpecificLanguageType> & {
    id: string
    name: string
    specifictype: string
    public_description: string
    alternativenames: string
    namelatin: string
    familyname: string

    snippet_general_desription: string
    snippet_grow_and_plant: string
    snippet_takle_care: string
    snippet_fertilize: string
    snippet_crop: string
    snippet_advice: string
}
export type SpecificLanguageType = {
    name?: string
    specifictype?: string
    namegroup?: string
    public_description?: string
    alternativenames?: string
};


export type ObjectSortType = {
    field?: string,
    direction?: "asc" | "desc"
};


//export type ChangesType = Record<string, Record<LanguageCodeType, SpecificLanguageType>>
export type ChangesType = {
    [key: string]: PartialRecord<LanguageCodeType, SpecificLanguageType>
};

export type SnippetsType = {
    snippetName: string
    snippetDescription: string
    id: string
    no?: string
    en?: string
    "en-us"?: string,

    no_state?: TranslationStateType
    en_state?: TranslationStateType
    "en-us_state"?: TranslationStateType,
}
export type SnippetsChangeType = {
    [x: string]: {
        no?: string,
        en?: string,
        "en-us"?: string
    }
}